import { Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'

import commentImg from '../../../../images/game-fact/carton jaune.png'
import { GAME_FACT_COMMENT } from '../constants.js'
import { useGameFact } from '../useGameFact.js'
import { getVisualTimer } from '../../sports/rules.js'

const RecapComment = ({state, match, inHistory}) => {
    const {target, timer, comment, title, period} = state

    const [img] = useGameFact({type : GAME_FACT_COMMENT})
  
    let fullTarget = "Autre"
  
    if(target===match.homeTeam._id){
      fullTarget = match.homeTeam.name
    }else if(target===match.awayTeam._id){
      fullTarget = match.awayTeam.name
    }

    const actualPeriod = period ??  match.period
  
    return (
      <div style={{color : inHistory ? 'black' : 'white'}}>
        <img src={img} width={150}/>
        <Typography>Cible : {fullTarget}</Typography>
        <Typography>Titre : {title}</Typography>
        <Typography>Commentaire : {comment}</Typography>
        {(timer !== 0 || period !== 0) && <Typography>Minute : {getVisualTimer(actualPeriod, timer, match.discipline)}</Typography>}
      </div>
    )
  }

export default RecapComment